module.exports = __webpack_public_path__ + "img/家用电器2.868fc2e8.jpg";